import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import {
    IQueryContextChange,
    QueryContextSettingID,
} from 'src/app/services/query-context/models/IQueryContext';
import {
    QueryContextChange,
    QueryContextService,
} from 'src/app/services/query-context/query-context.service';

// TODO flatten
export interface ISingleSelectSettingDashboardItem {
    options: {
        id: QueryContextSettingID;
        viewtype: 'singleSelect';
        displayName: string;
        /** Documentation shown in the label tooltip; omitted hides the info icon. */
        description?: string;
        /** Current value */
        value?: any;
        /** Possible values */
        selectOptions: any | { value: any; label: string }[];
    };
}

@Component({
    selector: 'app-single-select',
    templateUrl: './single-select.component.html',
    styleUrls: ['./single-select.component.scss'],
})
export class SingleSelectComponent implements OnInit {
    @Input()
    option!: ISingleSelectSettingDashboardItem['options'];
    @Output()
    change = new EventEmitter<IQueryContextChange>();
    // formControl = new FormControl('');
    selectedOption!: any;
    initialOption!: any;
    selectOptions!: { value: any; label: string }[];

    constructor(
        private queryContextService: QueryContextService,
        private cd: ChangeDetectorRef
    ) {
        // this.formControl.valueChanges.subscribe(observer => {
        //     this.onChange();
        // });
    }

    ngOnInit(): void {
        this.selectedOption = this.option.value;
        this.initialOption = structuredClone(this.option.value);
        // this.formControl.setValue(this.option.value, {emitEvent: false});
        this.queryContextService.appliedQueryContextEmitter.subscribe(
            this.queryContextSubscriber
        );
        this.selectOptions = (() => {
            if (!Array.isArray(this.option.selectOptions)) {
                throw new Error(
                    'SingleSelectComponent: selectOptions should be an array'
                );
            }
            if (
                // selectOptions[0] is a dict
                typeof this.option.selectOptions[0] === 'object' &&
                this.option.selectOptions[0] !== null &&
                'label' in this.option.selectOptions[0] &&
                'value' in this.option.selectOptions[0]
            ) {
                return this.option.selectOptions as {
                    value: any;
                    label: string;
                }[];
            }
            return this.option.selectOptions.map((option) => ({
                value: option,
                label: (option as string).toUpperCase(),
            }));
        })();
    }

    onChange(value: any) {
        this.selectedOption = value;
        console.log({
            msg: 'SingleSelectComponent.onChange',
            id: this.option.id,
            value: this.selectedOption,
        });
        this.queryContextService.changePendingQueryContext({
            setting: { id: this.option.id, value: this.selectedOption },
        });
    }

    queryContextSubscriber = (contextChange: QueryContextChange) => {
        if (contextChange.reason === 'InitialContext') {
            // if option id in contextChange.context.settings
            // then set value from contextChange.context.settings
            const setting =
                contextChange.context.settings[this.option.id] ??
                this.initialOption;
            if (setting !== this.selectedOption) {
                this.selectedOption = setting;
                this.cd.detectChanges();
            }
        }
    };
}
